module.exports = __webpack_public_path__ + "static/img/石洋.1d4658a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/st/石洋.jpg
// module id = Ns2x
// module chunks = 1